import {Layout, Menu} from "antd";
import {
    StarFilled,
    FileExclamationFilled,
    RightCircleOutlined,
    HomeFilled,
    CodeSandboxOutlined,
    BuildFilled,
    UserOutlined,
    ProjectFilled,
    CalendarFilled
} from '@ant-design/icons';
import {Link} from "react-router-dom";
import {menuArray} from "../utils/menu";
import Can from "../components/Can";

const { SubMenu } = Menu;
const { Header, Content, Sider } = Layout;

export default function SideBar(){

    return (
        <Sider width={250} className="sidebar">
            <Menu
                mode="inline"

                //defaultSelectedKeys={['1']}
                defaultOpenKeys={['sub1']}
                style={{borderRight: 0}}
            >

                {menuArray.map((item, idx) => (
                    <>
                        {item.subMenuArray.length > 0 ? (
                            <SubMenu key={"sub-main-list" + idx} icon={item.icon} title={item.name}>
                                {item.subMenuArray.map((item, idx) => (
                                    <Menu.Item icon={item.icon} key={"sub-list-" + idx}>
                                        {item.name}
                                        <Link to={item.route}/>
                                    </Menu.Item>
                                ))}
                            </SubMenu>
                        ) : (
                            <Can roles={item.roles}>
                                <Menu.Item icon={item.icon} key={"side-list" + idx}>

                                        {item.name}
                                        <Link to={item.route}/>


                                </Menu.Item>
                            </Can>


                        )}
                    </>

                ))}
            </Menu>
        </Sider>
    );
}
